import anime from 'animejs/lib/anime.es.js';

export default class H2Animator {
    constructor(selector = 'h2') {
        this.elements = [...document.querySelectorAll(selector)];
        if (!this.elements.length) return;
        this.wrapWords();
        this.animate();
    }

    wrapWords() {
        this.elements.forEach(el => {
            const text = el.textContent.trim();
            if (!text) return;
            const words = text.split(/\s+/);
            el.innerHTML = '';

            const lineWrapper = document.createElement('div');
            lineWrapper.classList.add('h2-line');

            words.forEach((word, idx) => {
                const wordWrap = document.createElement('span');
                wordWrap.classList.add('h2-word');

                const inner = document.createElement('span');
                inner.classList.add('h2-word-inner');
                inner.textContent = word;

                wordWrap.appendChild(inner);
                lineWrapper.appendChild(wordWrap);

                // preserve normal spacing between words
                if (idx < words.length - 1) lineWrapper.appendChild(document.createTextNode(' '));
            });

            el.appendChild(lineWrapper);
        });
    }

    animate() {
        anime.timeline({ loop: false })
            .add({
                targets: '.h2-word-inner',
                translateY: [100, 0],
                opacity: [0, 1],
                easing: 'easeOutExpo',
                duration: 1500,
                delay: (el, i) => 200 * i
            });
    }
}